import { assetUrl } from "../../../../Utils/assetUrl";
import React, {
  useRef,
  useState,
  useContext,
  useEffect,
  Suspense,
} from "react";
import Lottie from "lottie-web";
import MyContext from "../../../../context/MyContext";
import TickerContext from "../../../../context/ticker";
import AuthContext from "../../../../context/userAuth.context";
import Swal from "sweetalert2";
const MyLottieAnimation = React.lazy(() => import("./MyLottieAnimation"));

const PopCharFurther = ({
  fileName,
  data,
  obj,
  OpeningfromPanel,
  isPremiumCharacter,
}) => {
  var ActiveFrame = {
    Male: {
      Default: { frame: 0 },
      Happy: { frame: 50 },
      Sad: { frame: 37 },
      Satisfied: { frame: 60 },
      Wave: { frame: 33 },
      Angry: { frame: 33 },
      Walk: { frame: 33 },
      Talking: { frame: 33 },
      Clap: { frame: 33 },
      Thinking: { frame: 33 },
    },
    Female: {
      Default: { frame: 0 },
      Happy: { frame: 50 },
      Sad: { frame: 37 },
      Satisfied: { frame: 60 },
      Wave: { frame: 100 },
      Angry: { frame: 33 },
      Walk: { frame: 33 },
      Talking: { frame: 33 },
      Clap: { frame: 60 },
      Thinking: { frame: 180 },
    },
  };

  const { authenticationData, Access, getLink } = useContext(AuthContext);

  const {
    timelineZoomVal,
    setLayersData,
    LayersData,
    calculateTimeByWidth,
    EditorZoom,
    clone,
    setRedoLayer,
    UndoLayer,
    setUndoLayer,
    calculateWidthByDuration,
    ChangeCount,
    setChangeCount,
    Tl_TotalTime,
    seteditableObject,
  } = useContext(MyContext);

  const { Goto, setGoto, TickerPosition } = useContext(TickerContext);
  var cName = fileName + "PlayedInPopUp";

  var JsonFullFrame = 0;
  if (data.gender) {
    JsonFullFrame = ActiveFrame[data?.gender][obj.poseName]
      ? ActiveFrame[data?.gender][obj.poseName].frame
      : 0;
  }

  const playref = useRef(null);

  const imgref = useRef(null);

  const [ChangedJson, setChangedJson] = useState(null);

  const [delayHandler, setDelayHandler] = useState(null);

  const [GestureImage, setGestureImage] = useState(
    assetUrl(authenticationData.ApiBaseURL, obj.poseLargeImg)
  );

  useEffect(() => {
    return () => {
      Lottie.destroy(cName);
    };
  }, []);

  const MouseOnChr = () => {
    setDelayHandler(
      setTimeout(() => {
        PlayAnimation();
      }, 400)
    );
  };

  const PlayAnimation = () => {
    if (!playref.current) return;

    if (ChangedJson == null) {
      const gets = Lottie.loadAnimation({
        container: playref?.current,
        name: cName,
        renderer: "svg",
        loop: true,
        autoplay: true,
        path: assetUrl(authenticationData.ApiBaseURL, fileName),
        rendererSettings: {
          preserveAspectRatio: "xMidYMin meet",
          viewBoxOnly: true,
          progressiveLoad: true,
        },
      });
      setChangedJson(gets);
      playref.current.style.display = "block";
      if (imgref.current) imgref.current.style.display = "none";
    } else {
      ChangedJson.play(cName);
      playref.current.style.display = "block";
      if (imgref.current) imgref.current.style.display = "none";
    }
  };

  function loadCharacter(svg) {
    return new Promise((resolve, reject) => {
      // The preview may not have drawn yet (mouse left quickly, or its file is still loading).
      if (!svg || !(svg instanceof Node)) return reject(new Error("No preview yet"));
      var xml = new XMLSerializer().serializeToString(svg);
      if (xml) {
        var svg64 = btoa(xml);
        var b64Start = "data:image/svg+xml;base64,";
        var image64 = b64Start + svg64;
        let img = new Image();
        img.onload = function () {
          resolve(img);
        };
        img.src = image64;
      } else {
        reject();
      }
    });
  }

  const mouseleave = () => {
    clearTimeout(delayHandler);
    if (ChangedJson != null) {
      ChangedJson.goToAndStop(JsonFullFrame, true, cName);
      if (!GestureImage)
        loadCharacter(playref.current.firstChild).then(function (img) {
          let can = document.createElement("canvas");
          can.width = img.width * 3;
          can.height = img.height * 3;
          const ctx = can.getContext("2d");
          ctx.drawImage(img, 0, 0);
          //console.log(can.toDataURL("image/png"));
        }).catch(() => {});
    }
  };

  function getRandomArbitrary(min, max) {
    return parseInt(Math.random() * (max - min) + min);
  }

  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  const AddCharacter = async () => {
    if (Access == "FE" && isPremiumCharacter) {
      Swal.fire({
        title: "Upgrade Required",
        html:
    `You have not purchased this upgrade yet. Please <a href=${getLink()} target='_blank'>upgrade</a> to unlock all features.`,
        icon: "info",
        cancelButtonColor: "#d33",
        backdrop: null,
      });
      return;
    }
    let stack = [...UndoLayer];
    let PrevArray = clone(LayersData);
    let Gimage = GestureImage;
    // Picture of this pose for the layer (multi-select dragging, thumbnails). The picture made from
    // the animation below is only ready later, so it was often still empty here and the layer got
    // the address ".../undefined" (a broken picture when several layers were dragged together).
    // The pose's own picture is used, which is also much smaller than an embedded copy.
    const poseImage = (obj && (obj.poseImg || obj.poseSmallImg)) || null;

    if (!Gimage) {
      if (ChangedJson) {
        ChangedJson.goToAndStop(JsonFullFrame, true, cName);

        loadCharacter(playref.current.firstChild).then(function (img) {
          let can = document.createElement("canvas");
          can.width = img.width * 3;
          can.height = img.height * 3;
          const ctx = can.getContext("2d");
          ctx.drawImage(img, 0, 0);
          setGestureImage(can.toDataURL("image/png"));
          Gimage = can.toDataURL("image/png");
        }).catch(() => {});
      } else {
        const gets = Lottie.loadAnimation({
          container: playref.current,
          name: cName,
          renderer: "svg",
          loop: true,
          autoplay: true,
          path: assetUrl(authenticationData.ApiBaseURL, fileName),
          rendererSettings: {
            preserveAspectRatio: "xMidYMin meet",
            viewBoxOnly: true,
            progressiveLoad: true,
          },
        });
        setChangedJson(gets);
        gets.addEventListener("enterFrame", function () {
          ChangedJson.goToAndStop(JsonFullFrame, true, cName);

          loadCharacter(playref.current.firstChild).then(function (img) {
            let can = document.createElement("canvas");
            can.width = img.width * 3;
            can.height = img.height * 3;
            const ctx = can.getContext("2d");
            ctx.drawImage(img, 0, 0);
            setGestureImage(can.toDataURL("image/png"));
            Gimage = can.toDataURL("image/png");
          }).catch(() => {});
          gets.removeEventListener("enterFrame");
        });
      }
    }
    if (stack.length < 10) {
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    } else {
      stack.shift();
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    }
    if (data.ChangePose) {
      const array = Array.from(LayersData);
      const resp = await fetch(assetUrl(authenticationData.ApiBaseURL, fileName));
      const jsonData = await resp.json();
      for (var i = 0; i < array.length; i++) {
        if (array[i].key === data.prvKey) {
          Lottie.destroy(array[i].AnimationId);
          array[i].character_FilePath = fileName;
          array[i].ImageSrc = poseImage || Gimage || array[i].ImageSrc;
          array[i].CharacterPlayed = true;
          array[i].JSONValue = jsonData;
          array[i].Added = true;
        }
      }

      setLayersData(array);
      setChangeCount(ChangeCount + 1);
    } else {
      var canvasHeight =
        document.getElementsByClassName("EditorTrackInner")[0].offsetHeight;
      var CanvasWidth =
        document.getElementsByClassName("EditorTrackInner")[0].offsetWidth;
      let _widthPercentage = 350 / CanvasWidth;
      let _heightPercentage = 440 / canvasHeight;
      let _width = (CanvasWidth * _widthPercentage) / 2;
      let _height = (canvasHeight * _heightPercentage) / 2;
      var top = getRandomArbitrary(0, canvasHeight - _height);
      var left = getRandomArbitrary(0, CanvasWidth - _width);

      if (ChangedJson != null) {
        ChangedJson.stop(cName);
      }
      playref.current.style.display = "none";
      if (imgref.current) imgref.current.style.display = "block";
      if (Goto.innerMenu == "Char") {
        const array = Array.from(LayersData);
        for (var i = 0; i < array.length; i++) {
          if (array[i].key === Goto.key) {
            Lottie.destroy(array[i].AnimationId);
            array[i].character_FilePath = fileName;
            //array[i].character_Gender =  data.gender;
            array[i].character_poses = data.poseList;
            array[i].ImageSrc = poseImage || Gimage || array[i].ImageSrc;
            array[i].CharacterPlayed = false;
          }
        }
        setLayersData(array);
        setChangeCount(ChangeCount + 1);
        setGoto({ menu: null, innerMenu: null, key: null });
      } else {
        var topIndex = 0;
        if (LayersData.length > 0) {
          topIndex = LayersData[LayersData.length - 1].layerIndex;
          topIndex = topIndex + 1;
        }
        var typelength = 1;
        var checkKey = 0;
        for (var i = 0; i < LayersData.length; i++) {
          LayersData[i].toolbar = false;
          if (LayersData[i].Editable === true) {
            LayersData[i].Editable = false;
            LayersData[i].showDiv = false;
          }
          if (LayersData[i].type === "Character") {
            typelength = typelength + 1;
          }
          if (LayersData[i].key >= checkKey) {
            checkKey = LayersData[i].key;
          }
        }
        let currentTime = calculateTimeByWidth(TickerPosition);
        let totalTime = calculateTimeByWidth(
          Tl_TotalTime.width - TickerPosition
        );

        let newEntryLayerData = {
          Added: true,
          AnimationId: makeid(7),
          key: checkKey + 1,
          type: "Character",
          bgColor: "#00adff",
          Name: `Character-${typelength}`,
          canvas: null,
          userFile: "xyz",
          layerIndex: topIndex,
          index: null,
          TimelineZoom: timelineZoomVal,
          duration: totalTime,
          startTime: currentTime,
          endTime: calculateTimeByWidth(Tl_TotalTime.width),
          visible: true,
          OutEffect: "none",
          InEffect: "none",
          typeIcon: "text_fields",
          EditorZoom: EditorZoom,
          //character_Setting:  data.settings,
          //character_Gender:  data.gender,
          character_FilePath: fileName, //with out .json
          character_poses: data.poseList,
          ImageSrc: poseImage || Gimage,
          startTransitionWidth: 0,
          startTransitionLeft: 0,
          endTransitionWidth: 0,
          endTransitionLeft: 0,
          x: left,
          y: top,
          opacity: 1,
          originalOpacity: 1,
          width: _width,
          height: _height,
          toolbar: true,
          FurtherSetting: false,
          lock: false,
          layerlock: false,
          opc: 1,
          hidden: false,
          Editable: true,
          CharacterStop: true,
          CharacterPause: false,
          CharacterPlayed: false,
          startPositionOnTimeline: 0,
          player: false,
          showDiv: true,
          flip: "scaleX(1)",
          rotateAngle: 0,
          InMultiDrag: false,
          ImageFrame: JsonFullFrame,
          JSONValue: (async () => {
            const resp = await fetch(
              assetUrl(authenticationData.ApiBaseURL, fileName)
            );
            const jsonData = await resp.json();
            newEntryLayerData.JSONValue = jsonData;
            newEntryLayerData.widthOnTimeline = calculateWidthByDuration(
              newEntryLayerData.duration
            );
            newEntryLayerData.endTransitionLeft =
              newEntryLayerData.widthOnTimeline -
              newEntryLayerData.endTransitionWidth;
            setLayersData(LayersData.concat(newEntryLayerData));
            setChangeCount(ChangeCount + 1);
            seteditableObject({
              showPanel: true,
              editableItem: newEntryLayerData,
            });
            return jsonData;
          })(),
        };
      }
    }
  };

  var sty = {
    display: "block",
    backgroundPosition: "center center",
    height: "115px",
    textAlign: "center",
    minWidth: "95px",
  };

  return (
    <>
      {OpeningfromPanel ? (
        <div
          style={sty}
          onMouseLeave={(event) => mouseleave(event)}
          onClick={() => AddCharacter()}
          onMouseEnter={(event) => MouseOnChr(event)}
        >
          {/* <canvas ref={playref} className='canv' width={100} height={100} style={{ display: 'none' }} /> */}
          <div
            ref={playref}
            className="canv"
            style={{ width: "95px", display: "none", margin: "0 auto" }}
          />

          {obj.poseSmallImg && (
            <img
              ref={imgref}
              src={assetUrl(authenticationData.ApiBaseURL, obj.poseSmallImg)}
              style={{ height: "100%" }}
              alt=""
            />
          )}
          {obj.poseImg && (
            <img
              ref={imgref}
              src={assetUrl(authenticationData.ApiBaseURL, obj.poseImg)}
              style={{ height: "100%" }}
              alt=""
            />
          )}

          {!obj.poseSmallImg && !obj.poseImg && (
            <div ref={imgref}>
              <Suspense fallback={<div>Loading</div>}>
                <MyLottieAnimation
                  path={assetUrl(authenticationData.ApiBaseURL, fileName)}
                  style={{
                    width: "100%",
                    height: "100%",
                    position: "absolute",
                    zIndex: "-999px",
                  }}
                />
              </Suspense>
            </div>
          )}

          {/* {fileName && (
            <div ref={imgref}>

              <Suspense fallback={<div>Loading</div>}>
                <MyLottieAnimation path={assetUrl(authenticationData.ApiBaseURL, fileName)} style={{
                  width: "100%",
                  height: "100%",
                  position: "absolute",
                  zIndex: "-999px",
                }} />
              </Suspense>
             
            </div>)} */}
        </div>
      ) : (
        <div
          style={sty}
          onMouseLeave={(event) => mouseleave(event)}
          onClick={() => AddCharacter()}
          onMouseEnter={(event) => MouseOnChr(event)}
        >
          {/* <canvas ref={playref} className='canv' width={100} height={100} style={{ display: 'none' }} /> */}
          <div
            ref={playref}
            className="canv"
            style={{ width: "95px", display: "none", margin: "0 auto" }}
          />
          {obj.poseSmallImg && (
            <img
              ref={imgref}
              src={assetUrl(authenticationData.ApiBaseURL, obj.poseSmallImg)}
              style={{ height: "100%" }}
              alt=""
            />
          )}

          {obj.poseImg && (
            <img
              ref={imgref}
              src={assetUrl(authenticationData.ApiBaseURL, obj.poseImg)}
              style={{ height: "100%" }}
              alt=""
            />
          )}

          {!obj.poseSmallImg && !obj.poseImg && (
            <div ref={imgref}>
              <Suspense fallback={<div>Loading</div>}>
                <MyLottieAnimation
                  path={assetUrl(authenticationData.ApiBaseURL, fileName)}
                  style={{
                    width: "100%",
                    height: "100%",
                    position: "absolute",
                    zIndex: "-999px",
                  }}
                />
              </Suspense>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default PopCharFurther;
